import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";
import { SettingsProvider } from "./lib/settings";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import DoorDetail from "./pages/DoorDetail";
import PdfCatalogs from "./pages/PdfCatalogs";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <LangProvider>
          <AuthProvider>
            <BrowserRouter>
              <Toaster
                position="top-right"
                gap={10}
                offset={20}
                toastOptions={{
                  classNames: {
                    toast:
                      "!rounded-none !border !border-neutral-200 !bg-white !text-neutral-900 !shadow-[0_10px_40px_-12px_rgba(0,0,0,0.18)] !px-4 !py-3.5 !gap-3 !font-sans",
                    title: "!text-[13px] !font-medium !tracking-tight",
                    description: "!text-xs !text-neutral-500",
                    icon: "!hidden",
                    success: "!border-l-[3px] !border-l-neutral-900",
                    error: "!border-l-[3px] !border-l-red-500",
                  },
                }}
              />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/doors/:id" element={<DoorDetail />} />
                <Route path="/pdfs" element={<PdfCatalogs />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </LangProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
